import { render } from "./index.vue?vue&type=template&id=03170e10&scoped=true&bindings={}"
import script from "./tracks-info.js?vue&type=script&lang=js"
export * from "./tracks-info.js?vue&type=script&lang=js"

import "./tracks-info.scss?vue&type=style&index=0&id=03170e10&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-03170e10"

export default script